import {Pipe, PipeTransform} from '@angular/core';
import {Role} from '../../models/usuario.interface';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  transform(value: Role[], ...args: unknown[]): string {
    const admin = value.find(role => role.id === 1);
    const master = value.find(role => role.id === 2);
    const user = value.find(role => role.id === 3);
    if (admin != null) {
      return 'Admin';
    } else if (master != null) {
        return 'Master';
    } else {
      return 'User';
    }

  }

}
